import type { SummaryRow } from "../../types/analytics"

interface Column {
  key: string
  label: string
}

interface SummaryTableProps {
  rows: SummaryRow[]
  columns: Column[]
  title?: string
  filePrefix?: string
  onRowClick?: (index: number) => void
}

const fmt = (v: number | null | undefined): string => {
  if (v == null) return "—"
  return v.toLocaleString()
}

const SummaryTable = ({
  rows,
  columns,
  title = "サマリー",
  filePrefix = "summary",
  onRowClick,
}: SummaryTableProps) => {
  const handleCsvDownload = () => {
    const header = ["", ...columns.map(c => c.label)].join(",")
    const body   = rows.map(row =>
      [
        row.label,
        ...columns.map(c => {
          const v = row.values[c.key]
          return v == null ? "-" : String(v)
        }),
      ].join(",")
    )
    const csv  = [ header, ...body ].join("\n")
    const blob = new Blob([ "\uFEFF" + csv ], { type: "text/csv;charset=utf-8;" })
    const url  = URL.createObjectURL(blob)
    const a    = document.createElement("a")
    const date = new Date().toISOString().split("T")[0]
    a.href     = url
    a.download = `${filePrefix}_${date}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <div className="summary-table">
      <div className="summary-table__header">
        <span className="summary-table__title">{title}</span>
        <button className="summary-table__csv-btn" onClick={handleCsvDownload}>
          ↓ CSV
        </button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table>
          <thead>
            <tr>
              <th></th>
              {columns.map(c => <th key={c.key}>{c.label}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr
                key={row.label}
                className={onRowClick ? "summary-table__row--clickable" : undefined}
                onClick={onRowClick ? () => onRowClick(i) : undefined}
              >
                <td>{row.label}</td>
                {columns.map(c => {
                  const v = row.values[c.key]
                  return (
                    <td key={c.key} className={v == null ? "null-value" : ""}>
                      {fmt(v)}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default SummaryTable
